export enum RecordingState {
    NONE= 'NONE',
    RECORDING= 'RECORDING',
    PAUSE= 'PAUSE',
    FINISH= 'FINISH',
}
